import { registerPlugin } from '@capacitor/core';
const Backgroundstep = registerPlugin('Backgroundstep', {
    web: () => import('./web').then(m => new m.BackgroundstepWeb()),
});
export * from './definitions';
export { Backgroundstep };
//# sourceMappingURL=index.js.map